export default __webpack_public_path__ + "static/media/notes.5d6f1dbb.webp";